<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="row g-0 m-0 d-flex align-items-center mt-3 pt-4 pb-3">
            <div class="col-md-1 d-flex pe-4 justify-content-end">
                <div class="button-back" [routerLink]="['/settings/crud/meter-model']">
                    <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
                </div>
            </div>
            <div class="col-md-6 pb-2">
                <h2 class="col pb-2 m-0 title">
                    {{"METER_MODEL_VERSIONS_TITLE" | translate}}

                </h2>
                <h6 class="col subtitle">
                    {{"METER_MODEL_VERSIONS_SUBTITLE" | translate}}
                </h6>
            </div>
            <div class="col-md-5 d-flex justify-content-end pe-4">
                <button class="button-add-device text-nowrap" (click)="addNew()">
                    {{"ADD" | translate}}
                </button>
            </div>
        </div>
        <div class="row g-0 m-0 pt-3">
            <table>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"VERSION" | translate}}</span>
                        </th>
                        <th>
                            <img alt="Column" src="assets/device/column-menu.svg" />
                            <span>{{"CREATED_ON" | translate}}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i=index" (click)="handleRowClick(row.id)">
                        <td></td>
                        <td>
                            <span>{{ row.version }}</span>
                        </td>
                        <td>
                            <span [title]="row.createdAt | date: 'dd MMM yyyy, h:mm:ss a'">{{ row.createdAt | date: 'dd MMM yyyy, h:mm:ss a' }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfReminders" [pageSize]="pageSize"
            [currentPage]="currentPage" (pageChange)="pageChange($event)">
        </app-pagination>
    </div>
</div>